import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

const { auth } = environment;

export const authCodeFlowConfig: AuthConfig = {
    issuer: auth.issuer,

    redirectUri: `${auth.selfUrl}/signin-oidc`,
    postLogoutRedirectUri: `${auth.selfUrl}/logout`,
    clientId: auth.clientId,
    responseType: 'code',
    scope: auth.scope,
    showDebugInformation: true,
    useSilentRefresh: true
};